import TheGrid from '@/views/products/varieties/grid'
import Edit from '@/views/products/varieties/edit'

export default {
  path: '/products/varieties',
  redirect: '/products/varieties/index',
  name: 'varieties',
  meta: {
    auth: {
      redirect: {
        name: 'varieties.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'varieties.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'varieties.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'varieties.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
